// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bluetooth"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 7L12 12M12 12L17 17L12 21.5V12ZM12 12L7 17M12 12L17 7L12 2.5V12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BluetoothIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bluetooth',
    ref,
    icon: element,
  },
));

BluetoothIcon.displayName = 'BluetoothIcon';

export default BluetoothIcon;
